import { render, staticRenderFns } from "./BotaoRelatorioRastreabilidade.vue?vue&type=template&id=54253346&lang=pug"
import script from "./BotaoRelatorioRastreabilidade.vue?vue&type=script&lang=js"
export * from "./BotaoRelatorioRastreabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports